var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    {
      staticClass:
        "navbar navbar-expand-lg justify-content-between bg-info px-3",
    },
    [
      _c(
        "button",
        {
          staticClass:
            "navbar-toggler btn navbar-btn btn-sm btn-secondary p-1 mb-1 me-1",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              _vm.togglerCollapsed = !_vm.togglerCollapsed
            },
          },
        },
        [_c("span", { staticClass: "fas fa-filter text-white" })]
      ),
      _vm._v(" "),
      _c("favorite-tool", {
        attrs: { active: _vm.favActive },
        on: {
          click: function ($event) {
            return _vm.$emit("toggle-favorites", !_vm.favActive)
          },
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "ml-auto" }, [
        _c("form", { staticClass: "form-inline" }, [
          _c("div", { staticClass: "d-flex flex-nowrap" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.search,
                  expression: "search",
                },
              ],
              staticClass: "form-control me-sm-2",
              attrs: { type: "search", placeholder: "Quick Search" },
              domProps: { value: _vm.search },
              on: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.$emit("search", _vm.search)
                },
                input: [
                  function ($event) {
                    if ($event.target.composing) return
                    _vm.search = $event.target.value
                  },
                  function ($event) {
                    return _vm.onSearchInput()
                  },
                ],
              },
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.$emit("search", _vm.search)
                  },
                },
              },
              [_c("span", { staticClass: "fa fa-search" })]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      !_vm.togglerCollapsed
        ? _c("div", { staticClass: "c-node-drawer fade-in" }, [
            _c(
              "a",
              {
                staticClass: "btn btn-outline float-end",
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    _vm.togglerCollapsed = true
                  },
                },
              },
              [_c("i", { staticClass: "fas fa-times" })]
            ),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "nav bg-light flex-column pt-5" },
              _vm._l(_vm.nodes, function (node) {
                return _c("li", { key: node.id, staticClass: "nav-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link",
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.onFilterNode(node)
                        },
                      },
                    },
                    [_vm._v(_vm._s(node.name))]
                  ),
                ])
              }),
              0
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }